(function () {
  'use strict';

  /**
   * @author Dahang Xu
   * @description factory of Semafone CreditCardService
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')
    .factory('uteSemafoneService', _service);

  _service.$inject = [];

  /* @ngInject */
  function _service() {

    var token = '',
      cardScheme = '',
      maskedCardNumber = '',
      validCard = true,
      semafoneValidationState = '',
      expectedSecurityCodeLength = '';

    var service = {
      setToken: setToken,
      getToken: getToken,
      getMaskedToken: getMaskedToken,
      setCardScheme: setCardScheme,
      getCardScheme: getCardScheme,
      setMaskedCardNumber: setMaskedCardNumber,
      getMaskedCardNumber: getMaskedCardNumber,
      setSemafoneValidationState: setSemafoneValidationState,
      getSemafoneValidationState: getSemafoneValidationState,
      setValidCard: setValidCard,
      isValidCard: isValidCard,
      clearData: clearData,
      getExpectedSecurityCodeLength: getExpectedSecurityCodeLength,
      setExpectedSecurityCodeLength: setExpectedSecurityCodeLength
    };

    return service;

    function getMaskedToken(token) {
      if (token) {
        if (token.length === 15) {
          return '**** ****** *' + token.substr(11);
        } else {
          return '**** **** **** ' + token.substr(12);
        }
      } else {
        return '';
      }
    }

    function setToken(semafoneToken) {
      token = semafoneToken;
    }

    function getToken() {
      return token;
    }

    function setCardScheme(semafonecardScheme) {
      cardScheme = semafonecardScheme;
    }

    function getCardScheme() {
      return cardScheme;
    }

    function setMaskedCardNumber(semafonemaksedCardNumber) {
      maskedCardNumber = semafonemaksedCardNumber;
    }

    function getMaskedCardNumber() {
      return maskedCardNumber;
    }

    function setSemafoneValidationState(semafoneValidateState) {
      semafoneValidationState = semafoneValidateState;
    }

    function getSemafoneValidationState() {
      return semafoneValidationState;
    }

    function setValidCard(cardState) {
      validCard = cardState;
    }

    function isValidCard() {
      return validCard;
    }

    function clearData() {
      token = '';
      cardScheme = '';
      maskedCardNumber = '';
      validCard = true;
      semafoneValidationState = '';
    }

    function getExpectedSecurityCodeLength() {
      return expectedSecurityCodeLength;
    }

    function setExpectedSecurityCodeLength(securityCodeLength) {
      expectedSecurityCodeLength = securityCodeLength;
    }
  }
})();
